/**
 * API endpoints for tournaments
 */
export class TournamentsAPI {
    apiClient;
    controllerUrl;
    /**
     * Create a new TournamentsAPI
     * @param apiClient - The API client
     * @param baseUrl - The base URL for API requests
     */
    constructor(apiClient, baseUrl) {
        this.apiClient = apiClient;
        this.controllerUrl = `${baseUrl}/Tournaments`;
    }
    /**
     * Get all tournaments
     * @returns Promise with the tournaments
     */
    async get() {
        return this.apiClient.get(this.controllerUrl);
    }
    /**
     * Get a tournament by ID
     * @param tournamentId - The tournament ID
     * @param includeData - Whether to include data
     * @returns Promise with the tournament
     */
    async getTournament(tournamentId, includeData = false) {
        if (!tournamentId)
            return null;
        const url = `/${tournamentId}`;
        return this.apiClient.get(this.controllerUrl + url, { includeData });
    }
    /**
     * Get a tournament game
     * @param tournamentId - The tournament ID
     * @param matchId - The match ID
     * @returns Promise with the game
     */
    async getTournamentGame(tournamentId, matchId) {
        if (!tournamentId)
            return null;
        if (!matchId)
            return null;
        const url = `/${tournamentId}/games/${matchId}`;
        return this.apiClient.get(this.controllerUrl + url);
    }
    /**
     * Update a tournament game
     * @param tournamentId - The tournament ID
     * @param matchId - The match ID
     * @param data - The update data
     * @returns Promise with the result
     */
    async putTournamentGame(tournamentId, matchId, { startTime, finishTime, whiteResult, blackResult, }) {
        if (!tournamentId)
            return null;
        if (!matchId)
            return null;
        const url = `/${tournamentId}/games/${matchId}`;
        return this.apiClient.put(this.controllerUrl + url, {
            startTime,
            finishTime,
            whiteResult,
            blackResult,
        });
    }
    /**
     * Get user tournaments
     * @param userId - The user ID
     * @returns Promise with the tournaments
     */
    async getUserTournaments(userId) {
        if (!userId)
            return null;
        const url = `/${userId}/tournaments`;
        return this.apiClient.get(this.controllerUrl + url);
    }
    /**
     * Participate in round
     * @param tournamentId - The tournament ID
     * @param username - The username
     * @param roundNumber - The round number
     * @param toRoundNumber - The to round number
     * @returns Promise with the result
     */
    async participateInRound(tournamentId, username, roundNumber, toRoundNumber) {
        if (!tournamentId)
            return null;
        if (roundNumber == null)
            return null;
        const url = `/${tournamentId}/players/${username}`;
        return this.apiClient.put(this.controllerUrl + url, {
            roundNumber,
            toRoundNumber,
        });
    }
    /**
     * Get tournament subscriptions
     * @param tournamentId - The tournament ID
     * @param planIds - The plan IDs
     * @returns Promise with the subscriptions
     */
    async getTournamentSubscriptions(tournamentId, planIds) {
        if (!tournamentId)
            return null;
        if (!planIds)
            return [];
        const url = `/${tournamentId}/subscriptions`;
        return this.apiClient.get(this.controllerUrl + url, {
            planId: planIds.join(","),
        });
    }
}
